import type { SpyReportLifeforms } from "./types"

class Client {
    base_url: string

    constructor(base_url?: string) {
        if (base_url === undefined) {
            base_url = '/api'
        }
        this.base_url = base_url
    }

    async spy(key: string): Promise<SpyReportLifeforms> {
        return fetch(`${this.base_url}/v4/spy/${key}`)
            .then(response => response.json())
    }

    async share(data: any): Promise<any> {
        return fetch('http://127.0.0.1:8787/api/v3/share', {
            method: "POST",
            body: JSON.stringify(data)
        }).then(response => response.json())
    }
}

export { Client }